import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  IconButton,
} from '@chakra-ui/react';

import style from './Modal.style';
import IModalProps from './Modal.type';

import { Icon } from '@/components';

const BaseModal = ({
  title,
  children,
  isOpen,
  onClose,
  footer,
  showCloseButton = true,
  closeOnOverlayClick = true,
  size,
  contentStyle,
  isTitleCentered,
  isVendorRating,
  isReviewRating,
  isMarketPlace,
  ...rest
}: IModalProps) => {
  const modalStyle = style({
    showCloseButton,
    size,
    isVendorRating,
    isReviewRating,
    isMarketPlace,
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={closeOnOverlayClick}
        isCentered
        size={size}
        {...rest}
      >
        <ModalOverlay />
        <ModalContent
          data-title={!!title}
          sx={{ ...modalStyle.root, ...contentStyle }}
        >
          {!!title && (
            <ModalHeader sx={modalStyle.header}>
              <Flex
                sx={modalStyle.headerInnerContainer}
                data-title-center={!!isTitleCentered}
              >
                {title}
              </Flex>
            </ModalHeader>
          )}

          {isMarketPlace && (
            <IconButton
              aria-label="Close"
              icon={
                <Icon
                  name="MarketPlaceCloseIcon"
                  sx={{
                    height: '44px',
                    width: '44px',
                    color: '#2A353D',
                    opacity: '50%',
                  }}
                />
              }
              variant="ghost"
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: '24px',
                _rtl: {
                  left: '12px',
                },
                _ltr: {
                  right: '12px',
                },
                _hover: {
                  background: 'none',
                },
              }}
            />
          )}

          {showCloseButton && <ModalCloseButton sx={modalStyle.closeButton} />}
          <ModalBody>{children}</ModalBody>
          {footer && <ModalFooter sx={modalStyle.footer}>{footer}</ModalFooter>}
        </ModalContent>
      </Modal>
    </>
  );
};
export default BaseModal;
